"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _Icon = _interopRequireDefault(require("./Icon"));

var Styled = _interopRequireWildcard(require("./Social.style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Social = function Social(_a) {
  var urls = _a.urls;
  return React.createElement(Styled.Social, null, (0, _map2["default"])(urls, function (url, index) {
    return React.createElement(Styled.IconItem, {
      key: index
    }, React.createElement(_Icon["default"], {
      url: url
    }));
  }));
};

var _default = Social;
exports["default"] = _default;